<template>
  <div>
    <DataTable
      class="q-mt-md"
      name="identityProvidersTable"
      :data="tableData"
      :columns="columns"
      :columnItems="columnItems"
      rowKey="id"
      :filter-placeholder="$t('Search for identity providers')"
      :loading="loading"
    >
      <template v-slot:body-cell-action="{ props }">
        <Td :props="props">
          <DropdownMenu
            :items="dropdownMenuItems"
            @click="onClickMenuAction($event, props.row.id)"
          />
        </Td>
      </template>
    </DataTable>

    <DeleteModal v-model="deleteModalVisible" :deleteId="deleteId" />
  </div>
</template>

<script>
import DropdownMenu from '@design-system/components/DropdownMenu.vue';
import DataTable from '@design-system/components/DataTable/DataTable';
import Td from '@design-system/components/DataTable/Td';
import DeleteModal from './IdentityProviderDialogDelete';

const messages = {
  en: {
    'Search for identity providers': 'Search for identity providers',
    Name: 'Name',
    Action: 'Action',
    Edit: 'Edit',
    Delete: 'Delete',
  },
  ja: {
    'Search for identity providers': 'IdP 検索',
    Name: '名前',
    Action: 'アクション',
    Edit: '編集',
    Delete: '削除する',
  },
};

export default {
  name: 'DataTableIdentityProviderSettings',
  components: { DeleteModal, DropdownMenu, DataTable, Td },
  i18n: { messages },
  props: {
    tableData: Array,
  },
  data() {
    return {
      loading: false,
      filters: [
        {
          prop: ['name'],
          value: '',
        },
      ],
      deleteModalVisible: false,
      deleteId: '',
    };
  },
  computed: {
    columns() {
      return [
        {
          name: 'id',
          label: this.$t('ID'),
          field: 'id',
          align: 'left',
        },
        {
          name: 'name',
          label: this.$t('Name'),
          field: 'name',
          sortable: true,
          align: 'left',
        },
        {
          name: 'action',
          label: '',
          field: 'action',
          align: 'center',
          style: 'width:80px',
        },
      ];
    },
    columnItems() {
      return ['id', 'name', 'action'];
    },
    dropdownMenuItems() {
      return [
        {
          key: 'edit',
          label: this.$t('Edit'),
          icon: 'edit',
        },
        {
          key: 'delete',
          label: this.$t('Delete'),
          icon: 'delete',
          color: 'negative',
        },
      ];
    },
  },
  methods: {
    openDeleteModal() {
      this.deleteModalVisible = true;
    },
    onClickMenuAction($event, id) {
      switch ($event) {
        case 'edit':
          this.$emit('openModal', id);
          break;
        case 'delete':
          this.deleteModalVisible = true;
          this.deleteId = id;
          break;
      }
    },
  },
};
</script>
